import React, { createContext, useContext, useEffect } from 'react';
import { useUserProfile, UserProfile } from '@/hooks/useUserProfile';

interface UserPreferencesContextValue {
  currency: string;
  timezone: string;
  loading: boolean;
  update: (patch: Partial<Pick<UserProfile, 'currency' | 'timezone'>>) => Promise<void>;
}

const UserPreferencesContext = createContext<UserPreferencesContextValue>({
  currency: 'BRL',
  timezone: 'America/Sao_Paulo',
  loading: true,
  update: async () => {},
});

export function UserPreferencesProvider({ children }: { children: React.ReactNode }) {
  const { profile, loading, update } = useUserProfile();

  // Keep html lang always pt-BR (display language never changes in this app)
  useEffect(() => {
    document.documentElement.lang = 'pt-BR';
  }, []);

  return (
    <UserPreferencesContext.Provider
      value={{
        currency: profile.currency,
        timezone: profile.timezone,
        loading,
        update,
      }}
    >
      {children}
    </UserPreferencesContext.Provider>
  );
}

export function useUserPreferences() {
  return useContext(UserPreferencesContext);
}
